module.exports = __webpack_public_path__ + "static/media/inventory.18302e34.svg";